export default "__VITE_PUBLIC_ASSET__307728c2__"